import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { MonetizationType } from '@/@types/graphql-types';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useI18n } from '@/helpers/composables/useI18n';
import type { UpcomingReleaseBuybox } from '@/components/buybox-new/types.ts';
import { jwCheckIcon } from '@/plugins/global-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxUpcomingOfferNew',
  props: {
    release: null,
    title: null,
    isTitleInWatchlist: { type: Boolean }
  },
  emits: ["onNotifyMe"],
  setup(__props: any) {

const props = __props as {
	release: UpcomingReleaseBuybox;
	title: TitleDetail;
	isTitleInWatchlist?: boolean;
};

const BuyBoxInfoModal = () => import('@/components/buybox-new/BuyBoxInfoModal.vue');





const { t, tc } = useI18n();
const displayBuyBoxInfoModal = ref<boolean>(false);

const providerUnknown = computed(
	() => !props.release.offer.package || ['imd', 'tmd'].includes(props.release.offer.package.shortName)
);

const upcomingProviderIcon = computed(() => {
	if (providerUnknown.value) {
		const icon =
			props.release.offer.releaseType === 'THEATRICAL' ? 'JW_cinema_icon_wide' : 'JW_streaming_icon_wide';
		return `https://www.justwatch.com/${ASSETS_DIR}/img/icons/${icon}.{format}`;
	}
	return props.release.offer.package?.iconWide || props.release.offer.package?.icon;
});

const retailPrice = computed(() => {
	const subscriptionPrice = selectedPackagePlan.value?.retailPrice;
	if (!subscriptionPrice) return null;

	return t(hasfreeTrial.value ? 'WEBAPP_THEN_X_PER_MONTH' : 'WEBAPP_X_PER_MONTH', {
		price: subscriptionPrice,
	});
});

const hasfreeTrial = computed(() => {
	return !!selectedPackagePlan.value?.isTrial;
});

const selectedPackagePlan = computed(() => {
	if (!props.release.offer.package?.planOffers && props.release.offer.package?.planOffers.length! > 0) return null;
	return props.release.offer.package?.planOffers[0];
});

const freeTrialText = computed(() => {
	if (!hasfreeTrial.value || !selectedPackagePlan.value?.durationDays) {
		return null;
	}

	const days = selectedPackagePlan.value?.durationDays;
	if (days === 1) return t('WEBAPP_1_DAY_FREE');
	return t('WEBAPP_X_DAYS_FREE', { days: days });
});

const offerLabel = computed(() => {
	if (props.release.offer.package?.planOffers.length)
		return offerLabelFromMonetizationType(MonetizationType.Flatrate);
	if (props.release.offer.releaseType === 'THEATRICAL')
		return offerLabelFromMonetizationType(MonetizationType.Cinema);
	return monetizationType.value ? offerLabelFromMonetizationType(monetizationType.value) : '';
});

const monetizationType = computed(() => {
	return props.release.offer.package?.monetizationTypes[0];
});

const offerLabelFromMonetizationType = (monetizationType: MonetizationType) => {
	const monetizationTypeMapping = {
		ADS: tc('WEBAPP_FREE_WITH_ADS'),
		BUY: tc('WEBAPP_BUY'),
		CINEMA: tc('WEBAPP_CINEMA'),
		FAST: tc('WEBAPP_FREE_TV'),
		FLATRATE: tc('WEBAPP_SUBSCRIPTION'),
		FLATRATE_AND_BUY: tc('WEBAPP_BUY'),
		FREE: tc('WEBAPP_FREE'),
		RENT: tc('WEBAPP_RENT'),
	};
	return monetizationTypeMapping[monetizationType];
};

const ageRating = computed(() => (props.title.__typename !== 'Season' ? props.title.content.ageCertification : null));

const runtimeMins = computed(() => {
	return props.title.content?.runtime ? `${props.title.content.runtime}min` : null;
});

function toggleBuyBoxInfoModal(display: boolean) {
	displayBuyBoxInfoModal.value = display;
}

return { __sfc: true,BuyBoxInfoModal, props, t, tc, displayBuyBoxInfoModal, providerUnknown, upcomingProviderIcon, retailPrice, hasfreeTrial, selectedPackagePlan, freeTrialText, offerLabel, monetizationType, offerLabelFromMonetizationType, ageRating, runtimeMins, toggleBuyBoxInfoModal, jwCheckIcon, faBell, ProviderIcon }
}

})